// removed by extract-text-webpack-plugin
module.exports = {"Content":"_2kWAq9D4miw0flNIK_r41b","Claim":"_3NHlqFbiNtUHEiijT1lPTw","Search":"_2326q0uwhtUa3T1HTP85hF","SearchButton":"_16WkmabC_bI6lRq8ND88gR","Cases":"_2j5xxIOHpd4qs6aULC9zTb","Row":"_1v3XtOtNwQyfgrV9HtsqBl","List":"_17l2bW8BhUqdY2hHFpRyq3"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Cases/Cases.css
// module id = 419
// module chunks = 0